module.exports = __webpack_public_path__ + "static/img/y_24.40f0d9b6.jpg";